module.exports = __webpack_public_path__ + "static/img/kids_7.9be7452d.png";